const normalizarTexto = (texto = "") => {
  return texto
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

export default normalizarTexto;
